import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { BookingsSectionTitle } from "../styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Button from "@/common/elements/Button";
import Alert from "@/common/elements/Alerts";
import {
  base64ToBlob,
  base64ToImage,
  getFinalPath,
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form } from "antd";
import { useEffect, useRef, useState } from "react";
import Modal from "@/common/elements/Modal";

import SignaturePad from "react-signature-pad-wrapper";
import useDialog from "@/hooks/useDialog";
import API_ENDPOINTS, { PHOTOS_BASE_URL } from "@/util/api";
import api from "@/services/axios_custom";
import { SignImage } from "./style";
import { useSelector } from "react-redux";
import { FullscreenExitOutlined } from "@ant-design/icons";

const SignaturesForm = ({
  form,
  saveSignPhotos,
  selectSignatureData,
  isEdit,
  bookingsFieldsEnabled,
  setIsSignImgUploaded,
}) => {
  const [signShow, setSignShow] = useState(false);
  const sigCanvas = useRef(null);
  const { showDialog } = useDialog();
  const [signImg, setSignImg] = useState(null);
  const [signImgPayload, setSignImgPayload] = useState(null);
  const [isSignUpload, setisSignUpload] = useState(false);
  const fullSearch = useSelector(state => state.fullSearch);

  useEffect(() => {
    if (isNonEmptyVariable(selectSignatureData) && isEdit) {
      const photoUrl =
        selectSignatureData?.signature?.[0]?.photos?.[0]?.fullSizePath || "";
      const img = PHOTOS_BASE_URL + getFinalPath(photoUrl);

      setSignImg(img);
      setSignImgPayload({
        photos: selectSignatureData?.signature?.[0]?.photos,
      });
    } else {
      setSignImg(null);
    }
  }, [selectSignatureData, isEdit]);

  useEffect(() => {
    if (isNonEmptyVariable(signImgPayload)) {
      saveSignPhotos(signImgPayload);
    }
  }, [signImgPayload]);

  const onSignModalHide = () => {
    setSignShow(false);
  };

  const onSignModalShow = () => {
    setSignShow(true);
  };

  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const onSaveSign = () => {
    if (sigCanvas?.current) {
      if (sigCanvas?.current?.isEmpty()) {
        showDialog("info", {
          title: "Warning",
          content: "Signature is mandatory",
          confirmButtonText: "Ok",
        });
        return;
      }

      const trimmedDataURL = sigCanvas?.current?.toDataURL(); // save image as JPEG
      const imageUrl = base64ToBlob(trimmedDataURL);
      // console.log(imageUrl);

      const formData = new FormData();
      formData.append("imageType", "Discolored");
      formData.append("file", imageUrl, "sign.jpg");

      setisSignUpload(() => true);
      api
        .post(API_ENDPOINTS.imageUpload, formData, config)
        .then((response) => {
          const { body } = response.data;
          console.log(body);

          const img = PHOTOS_BASE_URL + getFinalPath(body?.fullSizePath);
          setSignImg(img);
          const photos = {
            photos: [body],
          };
          setSignImgPayload(() => photos);
          saveSignPhotos(photos);
          setIsSignImgUploaded(true);
        })
        .catch((error) => {
          console.error("Image upload failed:", error);
        })
        .finally(() => {
          onSignModalHide(false);
          setisSignUpload(() => false);
        });
    }
  };

  const onClearSign = () => {
    sigCanvas.current.clear();
  };

  return (
    <>
      <BookingsSectionTitle style={{ marginTop: "0" }}>
        <span>Signature Information</span>
      </BookingsSectionTitle>

      <Form form={form}>
        <StyledGridRow>
          <StyledGridCol span={10}>
            <FormItem
              name="signatureReasonID"
              label="Signature Reason"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Signature reason is required",
                },
              ] : []}
            >
              <Select
                options={getOptionsFromRefList(
                  "Signature_Reason",
                  false,
                  false,
                  true
                )}
                placeholder="Signature Reason"
                showSearch={true}
                variant="outlined"
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol span={16}>
            <FormItem name="legalese">
              <TextField inputType="textarea" rows="5" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={8}>
            <Button
              color="default"
              type="default"
              onClick={onSignModalShow}
              disabled={!bookingsFieldsEnabled}
            >
              Capture Signature
            </Button>
            {signImg ? (
              <SignImage
                src={signImg}
                style={{ Width: "100% !important" }}
                alt="Converted"
              />
            ) : (
              <p style={{ marginTop: "10px" }}>No Signature</p>
            )}
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol span={12}>
            <FormItem
              name="officerComments"
              label="Officer Comments"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Officer comments is required",
                },
              ] : []}
            >
              <TextField inputType="textarea" rows="5" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={12}>
            <FormItem name="signerComments" label="Signer Comments">
              <TextField inputType="textarea" rows="5" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>

      <Modal
        header="Capture Signature Details"
        show={signShow}
        onHide={onSignModalHide}
        size="md"
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: onSaveSign,
            isLoading: isSignUpload,
          },
          {
            key: "clear",
            text: "Clear",
            onClick: onClearSign,
          },
        ]}
        footerCloseAction
        footerCloseActionText="Cancel"
      >
        <SignaturePad
          ref={sigCanvas}
          options={{
            minWidth: 1,
            maxWidth: 5,
            penColor: "rgb(66, 133, 244)",
          }}
        />
      </Modal>
    </>
  );
};
export default SignaturesForm;
